import { ScheduleType } from 'mbs-ui-shared@models/schedule-type.enum';
import { WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { PlanDataFromStepsHelper } from 'wizards/helpers/plan-data-from-steps-helper/plan-data-from-steps-helper';
import { RestorePlanFromStepsHelper } from 'wizards/helpers/restore-plan-from-steps-helper/restore-plan-from-steps-helper';
import { BaseForPlanHelper } from 'wizards/models/base/base-models/base-for-plan-helper';
import { RestoreVMFormModel } from 'wizards/models/base/base-restore-vm-types';

export class BaseForRestoreVMPlanHelper extends BaseForPlanHelper {
  public static restoreVMModel: RestoreVMFormModel;

  public static getUpdatedPlan(plan, model: RestoreVMFormModel, settings: WizardHelpersSettings): any {
    this.restoreVMModel = model;
    this.updateSchedules(
      +ScheduleType[model.scheduleStep.ScheduleType] === ScheduleType.recurring,
      this.restoreVMModel.scheduleAdvancedStep
    );
    const newPlan = Object.assign({}, plan);
    this.updateModel(newPlan, settings);

    return newPlan;
  }

  protected static setSpecificStepsData(newPlan: any, settings: WizardHelpersSettings): void {}

  static updateModel(newPlan, settings: WizardHelpersSettings): void {
    RestorePlanFromStepsHelper.updateNewPlanByNameStep(newPlan, this.restoreVMModel.planNameStep);
    PlanDataFromStepsHelper.updateNewPlanByWhereBackupStep(newPlan, this.restoreVMModel.whereBackupStep);
    RestorePlanFromStepsHelper.updateNewPlanByBackupToRestoreStep(newPlan, this.restoreVMModel.backupToRestoreStep);
    RestorePlanFromStepsHelper.updateNewPlanByRestorePointStep(newPlan, this.restoreVMModel.restorePointStep, settings);
    RestorePlanFromStepsHelper.updateNewPlanByTypeDataStep(newPlan, this.restoreVMModel.typeDataStep, settings.planType);
    RestorePlanFromStepsHelper.updateRestoreSourceVM(
      newPlan,
      this.restoreVMModel.restoreSourceStep,
      this.restoreVMModel.restoreDisksStep,
      settings.planType
    );
    RestorePlanFromStepsHelper.updateRestoreDestinationVM(newPlan, this.restoreVMModel.destinationStep, settings.planType);
    RestorePlanFromStepsHelper.updateNewPlanByEncryptionOptionsStep(newPlan, this.restoreVMModel.encryptionOptionsStep);

    this.setDataFromRestore(newPlan, settings, this.restoreVMModel, newPlan.UseEncryption);

    this.setSpecificStepsData(newPlan, settings);

    RestorePlanFromStepsHelper.updateNewPlanByScheduleStep(
      newPlan,
      this.restoreVMModel.scheduleStep,
      this.restoreVMModel.scheduleAdvancedStep,
      settings.isUnix,
      settings.isNBF
    );
    PlanDataFromStepsHelper.updateNewPlanByPrePostActionsStep(
      newPlan,
      this.restoreVMModel.prePostActionsStep,
      !settings.allowPrePostActions
    );
    PlanDataFromStepsHelper.updateNewPlanByNotificationStep(newPlan, this.restoreVMModel.notificationStep);
    PlanDataFromStepsHelper.preparePlanForSending(newPlan);
  }
}
